import { Outlet } from 'react-router-dom';
import { NavigationProvider, NavigationSidebar } from './index';

interface NavigationLayoutProps {
  className?: string;
}

/**
 * Layout principal que incluye el sistema de navegación
 *
 * @example
 * ```tsx
 * // En tu router principal:
 * <Route path="/" element={<NavigationLayout />}>
 *   {protectedRoutes.map((route, index) => (
 *     <Route
 *       key={index}
 *       path={route.path}
 *       element={route.element}
 *     />
 *   ))}
 * </Route>
 * ```
 */
export default function NavigationLayout({ className }: NavigationLayoutProps) {
  return (
    <NavigationProvider>
      <NavigationSidebar className={className}>
        <Outlet />
      </NavigationSidebar>
    </NavigationProvider>
  );
}
